<template>
  <v-footer
    tile
    height="80"
    class="font-weight-medium shadow-sm ma-4 rounded-lg"
    :color="$vuetify.theme.dark ? 'dark' : 'white'"
    :dark="$vuetify.theme.dark"
    :inset="true"
  >
    <v-col class="text-left" cols="12">
      <div class="d-flex flex-row justify-space-between align-center">
        <!-- <div>
          <v-btn
            href="https://store.vuetifyjs.com/products/octavia-admin-pro"
            target="_blank"
            depressed
            color="warning"
            >Visit</v-btn
          >
        </div> -->
        <div>
          <strong class="text--disabled">
            <span>
              Powered By
              <a
                href="https://channelsoft.com.my"
                target="_blank"
                rel="noopener noreferrer"
                class="font-weight-medium"
              >
                Channel Soft Solutions
              </a>
            </span>
          </strong>
        </div>
      </div>
    </v-col>
  </v-footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getThemeMode"]),
  },
};
</script>
